import 'angular-spinner';

export default 'angularSpinner';



// WEBPACK FOOTER //
// ./src/common/wrappers/angular-spinner.js